<template>
    <modal size="lg" ref="modal" :hasFooter="false">
        <div class="card card-default">
            <div class="card-header" v-if="location">{{ location.name }} Review Widget</div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <label for="period">Select a period</label>
                        <multiselect id="period" class="mb-2" :options="selectOptions" track-by="id" label="name"
                                     v-model="periodSelected"></multiselect>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label for="bgColor">Background Color</label>
                        <colorpicker :color="bgColor" v-model="bgColor" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-primary mb-4" @click="gerenateScript" :disabled="!buttonEnabled">
                                Generate Script
                            </button>
                            <button class="btn btn-success mb-4" @click="openPreview" v-if="showScript">Preview</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="col-12 iframe" v-if="showScript">{{ message }}</div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div class="card card-default">
            <div class="card-header" v-if="location">{{ location.name }} Recent Reviews Widget</div>
            <div class="card-body">
                <div class="form-group">
                    <label for="amount">Number of Reviews (between 3 and 10)</label>
                    <input type="number" v-model="amount" id="amount" min="3" max="10" class="form-control">
                </div>
                <div class="form-group">
                    <label for="bgColor">Background Color</label>
                    <colorpicker :color="bgColor" v-model="bgColor"/>
                </div>
                <div class="form-group">
                    <label for="bgColor">Background Slide Color</label>
                    <colorpicker :color="bgSlideColor" v-model="bgSlideColor"/>
                </div>
                <div class="form-group">
                    <label for="bgFontColor">Font Color</label>
                    <colorpicker :color="bgFontColor" v-model="bgFontColor"/>
                </div>
                <div class="form-group">
                    <label for="bgStarColor">Stars Color</label>
                    <colorpicker :color="bgStarColor" v-model="bgStarColor"/>
                </div>
                <div
                    style="border-radius:4px;background-color:#2A2A2A;color:lightgray;border:1px gray solid;padding:8px;"
                    v-if="token">
                    {{ sliderScript }}
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <div class="d-flex justify-content-between">
                            <button v-if="!token" class="btn btn-primary mb-4" @click="generateToken">
                                Generate Script
                            </button>
                            <button class="btn btn-success mb-4" @click="openPreviewSlider">Preview</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </modal>
</template>

<script>
    export default {
        props: {
            location: { type: Object }
        },

        data: () => ({
            locationWidget: null,
            periodSelected: null,
            showScript: false,
            message: "",
            token: null,
            bgColor: "#edf0f2",
            bgSlideColor: '#FFFFFF',
            bgFontColor: '#727272',
            bgStarColor: '#F7C800',
            amount: 5
        }),

        watch: {
            location() {
                this.locationWidget = this.location;
                this.token = this.location.external_review_token;
                this.clearOptions();
            }
        },

        computed: {
            selectOptions() {
                return [
                    { id: "last-month", name: "In the last month" },
                    { id: "3-months-ago", name: "In the last three months" },
                    { id: "6-months-ago", name: "In the last six months" },
                    { id: "last-year", name: "In the last year" }
                ];
            },

            buttonEnabled() {
                return this.periodSelected !== null;
            },

            reviewToken() {
                return this.token;
            },

            iframeStyle() {
                return `style="border:none; margin:0; padding:0; overflow:hidden; height: 1200px; width: 800px"`;
            },

            defaultUrl() {
                return `${window.location.origin}/external-review?`;
            },

            reviewScript() {
                return `<iframe src="${this.reviewUrl}" ${this.iframeStyle}></iframe>`;
            },

            reviewUrl() {
                this.bgColor = this.bgColor.replace("#", "");
                return encodeURI(
                    `${this.defaultUrl}token=${this.token}&period=${this.periodSelected.id}&bgcolor=${this.bgColor}`
                );
            },
            sliderScript() {
                this.bgColor = this.bgColor.replace('#', '');
                this.bgSlideColor = this.bgSlideColor.replace('#', '');
                this.bgFontColor = this.bgFontColor.replace('#', '');
                this.bgStarColor = this.bgStarColor.replace('#', '');
                this.urlSlider = encodeURI(`${window.location.origin}/external-review-slider?token=${this.token}&amount=${this.amount}&bgcolor=${this.bgColor}&bgslidecolor=${this.bgSlideColor}&bgfontcolor=${this.bgFontColor}&bgstarcolor=${this.bgStarColor}`);

                const script = `
            <iframe src="${this.urlSlider}" style="border:none; margin:0; padding:0; overflow:hidden; height: 350px; width: 100%"></iframe>
            `;

                return script;
            },
        },

        methods: {
            open() {
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },

            clearOptions() {
                this.showScript = false;
                this.periodSelected = null;
            },

            gerenateScript() {
                this.showScript = true;
                this.generateToken();
            },

            generateToken() {
                if (this.token) {
                    return (this.message = this.reviewScript);
                }

                this.$http
                    .post(
                        this.$laroute.route("api.locations.generate-token", {
                            location: this.locationWidget.id
                        })
                    )
                    .then(({ data }) => {
                        this.token = data;
                        this.message = this.reviewScript;
                    });
            },
            openPreview() {
                window.open(this.reviewUrl, "_blank");
            },
            openPreviewSlider() {
                window.open(this.urlSlider, '_blank');
            },
        }
    };
</script>


<style lang="scss" scoped>
    .iframe {
        border-radius: 4px;
        background-color: #2a2a2a;
        color: lightgray;
        border: 1px gray solid;
        padding: 8px;
    }
</style>
